module.exports = __webpack_public_path__ + "img/logo.bf9b4c61.svg";